module.exports = __webpack_public_path__ + "static/media/lidcore-detection-6.d415031a.jpg";